module.exports = __webpack_public_path__ + "static/media/7.b95a588c.jpg";